import React, { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { FilterValue, neighborhoodsByCity, Restaurant } from "../../../components/types/types";
import { AppContext } from "../../../context/AppContext";
import { RestaurantContext } from "../../../context/RestaurantContext";

import HomeTopBarDesktop from "./topBar/homeTopBarDesktop";
import HomeTopBarMobile from "./topBar/homeTopBarMobile";


export type TopBarType = "primary" | "secondary";
const normalize = (value?: string | null): string => {
  return (
    value
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/['"]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase() || ""
  );
};
const useIsMobile = (breakpoint = 700) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width:${breakpoint}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const media = window.matchMedia(`(max-width:${breakpoint}px)`);
    const onChange = () => setIsMobile(media.matches);

    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isMobile;
};


interface HomeTopBarProps {
  type: TopBarType;
  fetchSections: (url: string,elem:string, options?: RequestInit, isInitialLoad?: boolean) => void;
  routeCity: string;
  routeFilter?: string;
  currentNeighborhood: string[];
  setCurrentNeighborhood: React.Dispatch<React.SetStateAction<string[]>>;
  setShowAll: React.Dispatch<React.SetStateAction<number>>,
  baseSortSection:string,
  globalFilter: FilterValue[];
  setGlobalFilter: Dispatch<SetStateAction<FilterValue[]>>;
  setShowWaitingSearch: Dispatch<SetStateAction<boolean>>;
  getNeighborhoodResultCount: (neighborhoods: string[]) => number;
  toolbarRestaurants: Restaurant[];
}

const HomeTopBar: React.FC<HomeTopBarProps> = (props) => {
  const isMobile = useIsMobile(700);
  const hasNeighborHood = neighborhoodsByCity[normalize(props.routeCity)] ?? [];


  const {setSearchCity,setValueSearchCity,setCoordonates,setFilterChoose,setDate_selected,setHour_selected,setCurrentHomePage} = useContext(AppContext);
  const {resetCityRestaurants} = useContext(RestaurantContext);

  const resetHome = useCallback(() => {
    setSearchCity("");
    setValueSearchCity("");
    setCoordonates({ latitude: "", longitude: "" });
    setFilterChoose([]);
    setDate_selected(null);
    setHour_selected("");
    setCurrentHomePage(1);
    resetCityRestaurants()
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setSearchCity,setValueSearchCity,setCoordonates,setFilterChoose,setDate_selected,setHour_selected,setCurrentHomePage,resetCityRestaurants]);

  if (isMobile) {
    return (
      <HomeTopBarMobile
        {...props}
        hasNeighborHood={hasNeighborHood}
        resetHome={resetHome}
        setShowAll={props.setShowAll}
        
      />
    );
  }

  return (
    <HomeTopBarDesktop
      {...props}
      resetHome={resetHome}
    />
  );
};

export default HomeTopBar;